import { NgModule } from '@angular/core';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { GridModule } from '@progress/kendo-angular-grid';
import { FarrisDialogModule } from '@farris/ui-dialog';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { SelectCommonEntityComponent } from './select-common-entity/select-common-entity.component';
import { TreeclassifierComponent } from './treeclassifier/treeclassifier.component';
import { CommonEntityListComponent } from './common-entity-list/common-entity-list.component';
import { InternalCommonEntityService } from './service/internal-common-entity-service';
import { CommonEntityService } from './service/common-entity-service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TreeViewModule,
    GridModule,
    LayoutModule,
    FarrisDialogModule,
    NoopAnimationsModule
  ],
  exports: [
    SelectCommonEntityComponent
  ],
  providers: [InternalCommonEntityService,CommonEntityService], // æå¡æä¾è
  declarations: [SelectCommonEntityComponent, TreeclassifierComponent, CommonEntityListComponent],
  entryComponents: [SelectCommonEntityComponent]
})
export class CommonEntitySelectModule {
  constructor() {
  }
}
